import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'main-page',
      component: Main,
      children: [
        {
          path: 'home-page',
          name: 'home-page',
          component: require('@/components/Home').default
        },
        {
          path: 'members-page',
          name: 'members-page',
          component: require('@/components/Members').default
        },
        {
          path: 'news-page',
          name: 'news-page',
          component: require('@/components/News').default
        },
        {
          path: 'photos-page',
          name: 'photos-page',
          component: require('@/components/Photos').default
        },
        {
          path: 'publication-page',
          name: 'publication-page',
          component: require('@/components/Publication').default
        },
        {
          path: 'about-page',
          name: 'about-page',
          component: require('@/components/About').default
        },
        {
          path: 'contact-page',
          name: 'contact-page',
          component: require('@/components/Contact').default
        },
        {
          path: 'equipment-page',
          name: 'equipment-page',
          component: require('@/components/Equipment').default
        },
        {
          path: 'research-page',
          name: 'research-page',
          component: require('@/components/Research').default
        },
        {
          path: 'research-detail-page',
          name: 'research-detail-page',
          component: require('@/components/ResearchDetail').default
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js